import { render, staticRenderFns } from "./User-address-form.vue?vue&type=template&id=0e01f643&scoped=true&"
import script from "./User-address-form.vue?vue&type=script&lang=js&"
export * from "./User-address-form.vue?vue&type=script&lang=js&"
import style0 from "./User-address-form.vue?vue&type=style&index=0&id=0e01f643&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e01f643",
  null
  
)

export default component.exports